import consumer from "./bigdata_consumer"

function onDatabasePage() {
  return !!document.querySelector("#accordionDatabases")
}

// Live progress percentages during upload / merge / verify (pure data — safe).
consumer.subscriptions.create("CompletePercentageChannel", {
  received(data) {
    if (!onDatabasePage()) return

    const { percentage_type, csv_file_id, folder_id, percentage } = data

    if (percentage_type === "csv_upload") {
      const el = document.querySelector(`.csv-upload-percentage-${csv_file_id}`)
      if (el) el.textContent = percentage
    } else if (percentage_type === "csv_merge") {
      const el = document.querySelector(`.merging-status-${folder_id}`)
      if (el) el.textContent = percentage
    } else if (percentage_type === "csv_verify") {
      const el = document.querySelector(`.csv-verify-percentage-${folder_id}`)
      if (el) el.textContent = percentage
    }
  }
})
